import { render, staticRenderFns } from "./GuideTile.vue?vue&type=template&id=c3509b12&scoped=true&lang=pug&"
import script from "./GuideTile.vue?vue&type=script&lang=js&"
export * from "./GuideTile.vue?vue&type=script&lang=js&"
import style0 from "./GuideTile.vue?vue&type=style&index=0&id=c3509b12&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3509b12",
  null
  
)

export default component.exports